import { analyticsService } from './AnalyticsService';
import {
  BIProvider,
  FirebaseProvider,
  MetaPixelProvider,
  ReactNativeProvider,
  YandexMetrikaProvider,
} from './providers';

export function initAnalytics(): void {
  analyticsService.registerProvider(new BIProvider());
  analyticsService.registerProvider(new FirebaseProvider());
  analyticsService.registerProvider(new MetaPixelProvider());
  analyticsService.registerProvider(new YandexMetrikaProvider());
  analyticsService.registerProvider(new ReactNativeProvider());

  analyticsService.initialize();
}
